import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-product-price',
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.scss']
})
export class ProductPriceComponent implements OnInit {

  @Input() product: {
      'id': '',
      'name': '',
      'price': 0,
      'discount': 0.0,
    }
  constructor() { }

  ngOnInit() {
  }

    numberWithCommas(x) {
    return (Math.floor(x)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  toint(x) {
    return Math.round(x);
  }

}
